import React from 'react'
import PropTypes from 'prop-types'

import {
  Paper,
  Box,
  Typography,
  Divider,
  Avatar,
  Tooltip,
  IconButton,
  Collapse,
  DialogContentText,
  makeStyles,
} from '@material-ui/core'

import { Delete } from '@material-ui/icons'

import { Permitted } from 'components/Permissions'
import * as service from 'service'
import helpers from 'helpers'
import styles from './styles'
import useConfirmDialog from 'hooks/useConfirmDialog'
import useSnackbar from 'hooks/useSnackbar'

const useStyles = makeStyles(styles)

const AutoPayment = ({ contract }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(
    !!contract.card || !!contract.yapayAccount,
  )
  const confirmDialog = useConfirmDialog()
  const snackbar = useSnackbar()

  const handleClickDeleteButton = () => {
    confirmDialog.open({
      title: 'Inativar pagamento automático',
      message: () => (
        <>
          <DialogContentText>
            Ao confirmar a inativação, as próximas cobranças deverão ser pagas
            de forma manual, contudo uma nova forma de pagamento automático
            poderá ser inserida no checkout posteriormente pelo cliente.
          </DialogContentText>
          <DialogContentText>
            Deseja inativar o pagamento automático?
          </DialogContentText>
        </>
      ),
      cancelButton: 'Cancelar',
      confirmButton: 'Inativar',
      handleConfirm: async () => {
        try {
          await service.recurrence.contracts.inactivateDebit({
            contractId: contract.id,
          })

          setOpen(false)
          snackbar.open({
            message: 'Pagamento automático desabilitado com sucesso!',
            variant: 'success',
          })
        } catch (error) {
          snackbar.open({
            message: 'Falha ao desabilitar pagamento automático!',
            variant: 'error',
          })
        }
      },
    })
  }

  if (!contract.card && !contract.yapayAccount) {
    return null
  }

  const Card = () => (
    <>
      <Avatar
        src={helpers.paymentMethods.image(contract.card.paymentMethod)}
        alt={helpers.paymentMethods.name(contract.card.paymentMethod)}
        className={classes.itemAvatar}
      ></Avatar>

      <div className={classes.item}>
        <Typography className={classes.itemTitle}>Titular</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          {contract.card.name}
        </Typography>
      </div>

      <div className={classes.item}>
        <Typography className={classes.itemTitle}>Cartão</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          {contract.card.maskedPan}
        </Typography>
      </div>

      <div className={classes.item}>
        <Typography className={classes.itemTitle}>Vencimento</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          {contract.card.month}/{contract.card.year}
        </Typography>
      </div>

      <div className={classes.item}>
        <Typography className={classes.itemTitle}>Bandeira</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          {helpers.paymentMethods.name(contract.card.paymentMethod)}
        </Typography>
      </div>
    </>
  )

  const Balance = () => (
    <>
      <Avatar
        src={helpers.paymentMethods.image('pagamento_com_saldo')}
        alt={helpers.paymentMethods.name('pagamento_com_saldo')}
        className={classes.itemAvatar}
      ></Avatar>

      <div className={classes.item}>
        <Typography className={classes.itemTitle}>Débito automático</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          Saldo Yapay
        </Typography>
      </div>

      <div className={classes.itemExtended}>
        <Typography className={classes.itemTitle}>Conta</Typography>
        <Typography variant="body2" className={classes.itemDescription}>
          {contract.yapayAccount.emailYapay}
        </Typography>
      </div>
    </>
  )

  return (
    <Collapse in={open} className={open ? classes.root : ''}>
      <Paper>
        <Box p={2}>
          <Typography variant="h4">Pagamento automático</Typography>
        </Box>

        <Divider />

        <div className={classes.container}>
          {!!contract.card && <Card />}
          {!!contract.yapayAccount && <Balance />}

          <Permitted tag="inactivate_debit_contract">
            <Tooltip title="Inativar">
              <IconButton
                className={classes.buttonDelete}
                onClick={handleClickDeleteButton}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </Permitted>
        </div>
      </Paper>
    </Collapse>
  )
}

AutoPayment.propTypes = {
  contract: PropTypes.object,
}

export default AutoPayment
